<div class="a4-paper" #contentContainer></div>
<div class="content" *ngFor="let item of items">{{ item }}</div>
<div class="a4-paper" *ngFor="let page of reportItems">
    <ng-container *ngFor="let item of page">
        <div [innerHTML]="convertHTML(item.content)"></div>
    </ng-container>
</div>